import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Form, Input, Button, Alert, Typography } from "antd";
import { useAdminAuth } from "./AdminAuthContext";

const { Title } = Typography;

export default function AdminLogin() {
  const { signIn } = useAdminAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(
    location.state && location.state.unauthorized
      ? "That account is not authorized for admin access."
      : ""
  );

  const onFinish = async (values) => {
    setLoading(true);
    setError("");
    const { error: signInError } = await signIn(
      values.email,
      values.password
    );
    setLoading(false);
    if (signInError) {
      setError(signInError.message);
      return;
    }
    const redirectTo =
      (location.state && location.state.from && location.state.from.pathname) ||
      "/admin/attendees";
    navigate(redirectTo, { replace: true });
  };

  return (
    <div
      style={{
        maxWidth: 400,
        margin: "4rem auto",
        background: "#fff",
        padding: "2rem",
        borderRadius: 12,
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      }}
    >
      <Title level={3} style={{ textAlign: "center" }}>
        Admin Login
      </Title>
      {error ? (
        <Alert
          type="error"
          message={error}
          style={{ marginBottom: "1rem" }}
          closable
          onClose={() => setError("")}
        />
      ) : null}
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Email"
          name="email"
          rules={[{ required: true, type: "email" }]}
        >
          <Input autoFocus />
        </Form.Item>
        <Form.Item
          label="Password"
          name="password"
          rules={[{ required: true }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Sign In
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}
